import React from 'react'

import { Icon, Verified } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import {
  ADVANCED_FILTER,
  PERSONAL_FILTER,
  PURCHASE_FILTER,
} from 'Pods/SearchPage/Store/constants'

const advancedFilters = [
  {
    value: ADVANCED_FILTER.COLLECTIONS_ONLY,
    labelKey: 'packs',
  },
  {
    value: ADVANCED_FILTER.HAS_MARMOSET,
    labelKey: 'has_marmoset',
  },
  {
    value: ADVANCED_FILTER.HAS_VIDEO,
    labelKey: 'has_video',
  },
  {
    value: ADVANCED_FILTER.CGT_STANDARD_ONLY,
    labelKey: 'cgt_standard',
    icon: Verified,
  },
]

const personalFilters = [
  {
    value: PERSONAL_FILTER.WISH_LIST_ONLY,
    labelKey: 'wish_list_only',
  },
  {
    value: PERSONAL_FILTER.LIKED_MODELS_ONLY,
    labelKey: 'liked_models_only',
  },
]

const purchaseFilters = [
  {
    value: PURCHASE_FILTER.EXCLUDE_PURCHASED_MODELS,
    labelKey: 'exclude_purchased_items',
  },
  {
    value: PURCHASE_FILTER.PURCHASED_MODELS_ONLY,
    labelKey: 'purchased_items_only',
  },
]

const buildFilters = (translate, filters) => filters.map(filter => ({
  value: filter.value,
  label: translate(`search_page.filters.advanced.${filter.labelKey}`),
}))

export const getAdvancedFiltersConfig = (translate) => [{
  label: translate('search_page.filters.advanced.group_label'),
  filters: advancedFilters.map(filter => ({
    value: filter.value,
    label: filter.icon
      ? (
        <span className="filter-wrapper__option--with-icon">
          <span>{translate(`search_page.filters.advanced.${filter.labelKey}`)}</span>
          <Icon notSpaced svgComponent={filter.icon} color="primary" size="small" />
        </span>
      )
      : translate(`search_page.filters.advanced.${filter.labelKey}`),
  })),
}]

export const getPersonalFiltersConfig = (translate) => [{
  label: translate('search_page.filters.advanced.personal_group_label'),
  filters: buildFilters(translate, personalFilters),
}]

export const getPurchaseFiltersConfig = (translate) => [{
  label: translate('search_page.filters.advanced.purchases_group_label'),
  filters: buildFilters(translate, purchaseFilters),
}]
